<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Auth } from 'aws-amplify'
import awsconfig from '@/aws-exports'

const BOT_SCRIPT_URL = 'https://bot.tacoai.net/chatbot.js'
const BOT_DATA_ID = process.env.VUE_APP_BOT_DATA_ID

// Keep client outside Vue reactivity (equivalent to React useRef)
let chatbotClient = null

export default {
  name: 'Bot',
  data() {
    return {
      chatOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      userSub: 'getSub',
    }),
  },
  mounted() {
    this.loadBotScript()
    this.setupAuthavaChatbotListener()
  },
  beforeDestroy() {
    chatbotClient = null
  },
  methods: {
    loadBotScript() {
      if (!BOT_DATA_ID) {
        console.error(
          'Configuration error: VUE_APP_BOT_DATA_ID environment variable is not set.'
        )
        return
      }

      if (document.querySelector(`script[src="${BOT_SCRIPT_URL}"]`)) {
        return
      }

      const script = document.createElement('script')
      script.src = BOT_SCRIPT_URL
      script.setAttribute('data-id', BOT_DATA_ID)
      script.setAttribute('data-hide-tool-tip', 'true')
      script.defer = true

      script.onload = () => {
        document.dispatchEvent(new Event('DOMContentLoaded'))
        window.dispatchEvent(new Event('load'))
      }

      document.head.appendChild(script)
    },

    setupAuthavaChatbotListener() {
      window.addEventListener('AuthavaChatbotReady', async (event) => {
        const { client } = event.detail
        chatbotClient = client

        const clientId = awsconfig.aws_user_pools_web_client_id
        client.setCognitoClientId(clientId)
        client.setCognitoUserSub(this.userSub)
        client.setTokenRefreshHandler(async () => {
          const session = await Auth.currentSession()
          return session.getIdToken().getJwtToken()
        })
        await client.refetchSettings()

        // Hide the entire host element by default — navbar button will show it
        const host = document.getElementById('authava-chatbot-host')
        if (host) {
          host.style.display = 'none'

          // Listen for clicks on the chatbot's own close button to sync our state
          const shadow = host.shadowRoot
          if (shadow) {
            shadow.addEventListener('click', (e) => {
              // Only catch the header close button, not the clear chat button
              // Both use .chatbot-close but only the header one has aria-label="Close chat"
              const closeBtn = e.target.closest('[aria-label="Close chat"]')
              const collapseBtn = e.target.closest('.chatbot-collapse')
              if (closeBtn || collapseBtn) {
                this.chatOpen = false
                host.style.display = 'none'
              }
            })
          }
        }
      })
    },

    hideLauncher() {
      const host = document.getElementById('authava-chatbot-host')
      const shadow = host?.shadowRoot
      if (!shadow) return

      const launcher = shadow.querySelector('.chatbot-launcher')
      if (launcher) {
        launcher.style.setProperty('display', 'none', 'important')
      }
    },

    openChat() {
      const host = document.getElementById('authava-chatbot-host')
      if (!host) return

      this.chatOpen = !this.chatOpen

      if (this.chatOpen) {
        host.style.display = ''
        const root = document.getElementById('authava-chatbot-root')
        if (root) root.style.display = ''
        if (chatbotClient) chatbotClient.open()
        this.hideLauncher()
        setTimeout(() => this.hideLauncher(), 300)
      } else {
        host.style.display = 'none'
        const root = document.getElementById('authava-chatbot-root')
        if (root) root.style.display = 'none'
      }
    },
  },
}
</script>
